import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../_services/auth.service';
import { RouterExtService } from '../_services/router-ext.service';
import { DataShareService } from '../_services/data-share.service';
import { TokenService } from '../_helpers/token.service';
import { MessageService } from 'primeng/api';
import { environment } from 'src/environments/environment';
import { CommonService } from '@ets/services/common.service';
import { API_URL } from '@ets/utility/constant/constant';
import { getCurrentUser, LOCAL_STORAGE_CONSTANT } from '@ets/utility/constant/storageConstant';
import { firstValueFrom } from 'rxjs';
@Component({
  selector: 'app-login-with-geo-one-sso',
  templateUrl: './login-with-geo-one-sso.component.html',
  styleUrls: ['./login-with-geo-one-sso.component.scss']
})
export class LoginWithGeoOneSsoComponent implements OnInit {

  loginImageSrc = environment.loginImage;
  version = environment.appVersion;
  loading: any;

  constructor(private router: Router,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private routerExtService: RouterExtService,
    private dataShareService: DataShareService,
    private tokenService: TokenService,
    private messageService: MessageService,
    private commonService: CommonService
  ) { }

  async ngOnInit(): Promise<void> {
    try {
      localStorage.setItem('reloadTabs', 'false')
      const ssoToken = this.route.snapshot.queryParamMap.get('sso_token');
      if (ssoToken) {
        const successSso = await this.handleSSOToken(ssoToken);
        if (successSso) {

          this.router.navigateByUrl('/pages/maptiler').then(resr => {
            setTimeout(() => {
              localStorage.setItem('reloadTabs', 'true');
              //   localStorage.setItem('refresh_token', res.refresh_token);
            }, 2000);

          })
        }
        else {
          this.router.navigateByUrl('/auth/login')
        }
      }
    } catch (error) {
      alert("Authentication with GeoOne SSO failed!");
      this.router.navigateByUrl("/auth/login");
    }
  }

  async handleSSOToken(ssoToken: string) {
    this.loading = true;
    return new Promise(async (resolve, reject) => {
      try {
        const userLoginData = {
          token: ssoToken
        }
        const response: any = await firstValueFrom(
            this.authenticationService.login(userLoginData, 'GeoOneSso')
        );
        this.tokenService.saveToken(response?.accessToken);

        // Await the user details
        const userDetails: any = await this.authenticationService.getUserDetails(
          response?.username
        );

        localStorage.setItem('currentUser', JSON.stringify(userDetails));

        this.dataShareService.isMenuListSuccess = true;
        this.dataShareService.userPolicyList = userDetails.modules; // No error now
          localStorage.setItem('userPolicyList', JSON.stringify(userDetails.modules)); // No error now
          this.getUserPriveleges()
        this.routerExtService.redirectUser();

        this.messageService.add({
          key: 't2',
          severity: 'success',
          summary: 'Success',
          detail: 'Login successfully',
        });
        resolve(true)
      } catch (error) {
        console.error('Error during SSO token handling:', error);
        reject(error)
      }
      reject(false)
    })
    this.loading = false;
  }

  getUserPriveleges() {
    this.commonService.getData(API_URL.GET_ROLE_PRIV_BY_USER_ID, { userId: getCurrentUser().userId }).subscribe({
      next: (res) => {
        let cc = JSON.stringify({ roleId: res.roleId, roleName: res.roleName, privileges: res.privileges })
        console.log("Formatted Data:", cc)

        let etsPriv = (LOCAL_STORAGE_CONSTANT.ETS_PRIV, cc)
        localStorage.setItem('etsPriv', etsPriv);
      }
    })
  }
}